import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { toast } from "sonner";
import { createMPPreference } from "@/lib/api";

const FEATURES = [
  "Debates ilimitados todos los días",
  "Todas las categorías desbloqueadas",
  "Ranking por categoría en el leaderboard",
  "Historial completo de tus debates",
  "Badge PRO + título visible para todos",
  "Pago único — PRO de por vida",
];

export default function ProGateModal({ open, onClose, onUpgraded, reason, score }) {
  const [loading, setLoading] = useState(false);

  const handleUpgrade = async () => {
    setLoading(true);
    try {
      const { checkout_url } = await createMPPreference();
      window.location.href = checkout_url;
    } catch (_e) {
      toast.error("No se pudo iniciar el pago. Intentá de nuevo.");
      setLoading(false);
    }
  };

  const title = reason === "category"
    ? "Categoría PRO"
    : reason === "leaderboard"
      ? "Top 3 bloqueado"
      : reason === "history"
        ? "Historial PRO"
        : reason === "revancha"
          ? "Tu rival quiere revancha"
          : "Usaste tus 3 debates de hoy";

  const subtitle = reason === "category"
    ? "Esta categoría es exclusiva para usuarios PRO."
    : reason === "leaderboard"
      ? "Solo los usuarios PRO ven el podio del leaderboard."
      : reason === "history"
        ? "Tu historial detallado es una funcionalidad PRO."
        : reason === "revancha"
          ? `Sacaste ${score || ""}/100 y estás en racha. Desbloqueá PRO para no parar hoy.`
          : "Volvé mañana o desbloqueá debates ilimitados con PRO.";

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center px-4 py-6"
          data-testid="pro-gate-modal"
        >
          <button
            onClick={onClose}
            className="absolute inset-0 bg-[#101010]/60 backdrop-blur-sm"
            aria-label="Cerrar"
            data-testid="pro-gate-backdrop"
          />
          <motion.div
            initial={{ y: 30, scale: 0.95 }}
            animate={{ y: 0, scale: 1 }}
            exit={{ y: 20, scale: 0.95 }}
            transition={{ duration: 0.25 }}
            className="relative bg-[#FFFDF5] border-4 border-[#101010] rounded-xl cm-shadow w-full max-w-md p-6 md:p-8"
          >
            <div className="inline-block bg-[#FF4C4C] text-white border-4 border-[#101010] cm-shadow-sm px-3 py-1 mb-4 rotate-[-2deg]">
              <span className="font-mono-cm text-xs font-bold uppercase tracking-widest">Desbloqueá PRO</span>
            </div>
            <h2 className="font-display uppercase text-2xl md:text-3xl mb-1.5" data-testid="pro-gate-title">{title}</h2>
            <p className="text-sm md:text-base text-[#101010]/80 mb-5" data-testid="pro-gate-subtitle">{subtitle}</p>

            <ul className="space-y-2 mb-6" data-testid="pro-gate-features">
              {FEATURES.map((f) => (
                <li key={f} className="flex items-start gap-2 text-sm md:text-base">
                  <span className="font-display text-[#A8FF76] -translate-y-0.5">✓</span>
                  <span className="font-medium">{f}</span>
                </li>
              ))}
            </ul>

            <button
              onClick={handleUpgrade}
              disabled={loading}
              data-testid="pro-gate-upgrade-button"
              className="cm-press w-full bg-[#FF4C4C] text-white border-4 border-[#101010] rounded-xl px-5 py-4 font-display uppercase text-base md:text-lg cm-shadow disabled:opacity-60"
            >
              {loading ? "Redirigiendo a MercadoPago..." : "Desbloquear PRO — $4.999"}
            </button>
            <button
              onClick={onClose}
              data-testid="pro-gate-close-button"
              className="w-full mt-3 text-center font-mono-cm text-xs uppercase tracking-widest underline underline-offset-4 text-[#101010]/70 hover:text-[#101010]"
            >
              {reason === "limit" ? "Volver mañana (gratis)" : "Volver"}
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
